module.exports = __webpack_public_path__ + "img/img7.b7c764b0.png";